import type { ReactNode } from 'react';
import styles from './Badge.module.css';

export interface BadgeProps {
  tone?: 'neutral' | 'pink' | 'cyan' | 'amber' | 'green';
  children: ReactNode;
}

export function Badge({ tone = 'neutral', children }: BadgeProps) {
  return <span className={[styles['badge'], styles[tone]].join(' ')}>{children}</span>;
}
